import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PrivateRoute } from '../../../auth'
import ListRequisites from '../ListRequisites'
import RequisiteTypes from './component/requisite-types/RequisiteTypes'
import FastTrackRequisites from '../FastTrackRequisites'
import ResuisiteClients from '../ResuisiteClients/ResuisiteClients'
import { EditRequisite } from '../EditRequisite'
import RequisiteHistoryPage from './component/balance-operations/RequisiteHistoryPage'
import RequisiteAuditPage from '../RequisiteAudit'
import { DEFAULT_ROLES } from '../../../../common/core/_consts'
import { REQUISITE_VIEW_ROLES, REQUISITE_WRITE_ROLES } from './core/access'

const RequisitePage: React.FC = () => {    
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    path='list-enabled'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <ListRequisites key={'reservationDisabledFalse'} reservationDisabled={false} />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='list-disabled'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <ListRequisites key={'reservationDisabledTrue'} reservationDisabled={true} />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='list-fasttrack'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <FastTrackRequisites />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='edit/:id'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <EditRequisite />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='edit'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <Navigate to='/error/404' />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='add'
                    element={
                        <PrivateRoute roles={REQUISITE_WRITE_ROLES} >
                            <EditRequisite />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='clients'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <Navigate to='/error/404' />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='clients/:id'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <ResuisiteClients />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='history/:id'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <RequisiteHistoryPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path=':id/history'
                    element={
                        <PrivateRoute roles={REQUISITE_VIEW_ROLES} >
                            <RequisiteAuditPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path='types'
                    element={
                        <PrivateRoute roles={DEFAULT_ROLES} >
                            <RequisiteTypes />
                        </PrivateRoute>
                    }
                />
                <Route index element={<Navigate to='list-enabled' />} />
            </Route>
        </Routes>
    )
}

export default RequisitePage
